import React from 'react'
import VerticalNavigation from "../components/VerticalNavigation";

const TimeSeriasAnalysis = () => {
  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        <div className="container bg-light rounded main_content mx-2">
        <div className='modal-body'>
            <ul className='nav nav-tabs' role='tablist'>
              <li className='nav-item'>
              <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#kms"
                  role="tab"
                >
                  <span className="d-none d-sm-block">ARIMA</span>
                </a>
              </li>
            </ul>
            <div className="tab-content p-3">
              <div className="tab-pane active" id='lr' role='tabpanel'>
                <h3 className='text-center'>
                  ARIMA MODEL
                </h3>
                <div className="d-flexjustify-content-between flex-wrap">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TimeSeriasAnalysis
